import { awaitNotNullzd1xp1uu2voc as awaitNotNull } from '../../../../../../reactive/com/lightningkite/reactive/extensions/WaitForNotNull.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import {
  get_rawSession1kjo1nj4tz6n0 as get_rawSession,
  get_session9cytjmfbg8nd as get_session,
} from '../../../sdk/UserSession.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { get_notNullContractorsjk9enub7uol as get_notNullContractor } from '../../../selectedContractor.mjs';
import { await1kke5zj2piplv as await_0 } from '../../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { ensureNotNull1e947j3ixpazm as ensureNotNull } from '../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import {
  initMetadataForFunctionReferencen3g5fpj34t8u as initMetadataForFunctionReference,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DirectDepositInfo1jikmxa3ta6ic as DirectDepositInfo } from './DirectDepositInfo.mjs';
import {
  _Constant___init__impl__v45mub34czko7zopf6l as _Constant___init__impl__v45mub,
  Constant3smypj7m9af27 as Constant,
} from '../../../../../../reactive/com/lightningkite/reactive/core/signals.mjs';
import { MemberRole_Admin_getInstance3iiznt2spfc6m as MemberRole_Admin_getInstance } from '../../../../../../crowpay-shared/com/crowpay/enums.mjs';
import { remembery2gxxk5pa2qe as remember } from '../../../../../../reactive/com/lightningkite/reactive/core/Remember.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../../components/nav/crowpay.mjs';
import { ContractorFinancialConnection7bkl9pu54014 as ContractorFinancialConnection } from '../../dialogs/SetupCustomerMethodDialog.mjs';
import {
  get_scrolling27q1yr4ng0cx8 as get_scrolling,
  get_padded3m3frjnjujncx as get_padded,
  sizeConstraints2hv7x4j4qpd36 as sizeConstraints,
} from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { RowOrCol3a33s3yce2tuv as RowOrCol } from '../../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { title1nssp3ryhwuqj as title } from '../../theming/Titles.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../../components/nav/AppDimensions.mjs';
import { get_section1qyzr1npzel2z as get_section } from '../../theming/sections.mjs';
import { Companion_getInstance2xbytizsyx2ps as Companion_getInstance } from '../../../../../../kiteui-library/com/lightningkite/kiteui/ViewWrapper.mjs';
import {
  render2bonfr4ls49sc as render,
  get_awaitingApprovalMessagemcfmnhjri98l as get_awaitingApprovalMessage,
  renderFinishRegistrationbdw1wx3e9bul as renderFinishRegistration,
  renderAwaitingApprovalsh6ugtdyt2je as renderAwaitingApproval,
  ContractorPage2yk275fy06uv3 as ContractorPage,
} from './IsContractorScreen.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_retrievePaymentInfo__nex0l8($this, $completion) {
  var tmp = awaitNotNull($this.lje_1, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  var tmp_0 = awaitNotNull(get_rawSession(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.tfw().mff_1.qfi(c.v5i_1, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var result = tmp_1;
  var tmp_2 = $this.uiw_1.gah(result, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_setupPaymentInfo__dfdck1($this, _this__u8e3s4, request, $completion) {
  var tmp = await_0(get_notNullContractor(), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var c = tmp;
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp_0 = await_0(this_0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var tmp_1 = tmp_0.tfw().mff_1.mfi(c, request, $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  return Unit_instance;
}
function *_generator_clearPaymentInfo__j19g9t($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().mff_1;
  var tmp_1 = await_0(get_notNullContractor(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_0.pfi(tmp_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_clearDirectPaymentInfo__cg71g6($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().mff_1;
  var tmp_1 = await_0(get_notNullContractor(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_0.ofi(tmp_1, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  return Unit_instance;
}
function *_generator_verifyBankInfo__73vm11($this, _this__u8e3s4, input, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = get_session();
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = tmp.tfw().mff_1;
  var tmp_1 = await_0(get_notNullContractor(), $completion);
  if (tmp_1 === get_COROUTINE_SUSPENDED())
    tmp_1 = yield tmp_1;
  var tmp_2 = tmp_0.nfi(tmp_1, input, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tmp_3 = $this.uiw_1.gah(tmp_2, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  return Unit_instance;
}
function ContractorBankInfo$contractor$lambda($this$remember) {
  return ensureNotNull($this$remember.baj($this$remember.baj(get_session()).jfv_1.eeo($this$remember.baj(get_notNullContractor()))));
}
var ContractorBankInfo$financeConnectionComplete$refClass;
function ContractorBankInfo$financeConnectionComplete$ref() {
  if (ContractorBankInfo$financeConnectionComplete$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.mje_1 = p0;
      }
      sao($completion) {
        return this.mje_1.nje($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    ContractorBankInfo$financeConnectionComplete$refClass = $;
  }
  return ContractorBankInfo$financeConnectionComplete$refClass;
}
function ContractorBankInfo$financeConnectionComplete$ref_0(p0) {
  var i = new (ContractorBankInfo$financeConnectionComplete$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'financeConnectionComplete';
  l.$arity = 0;
  return l;
}
var ContractorBankInfo$clearPaymentInfo$refClass;
function ContractorBankInfo$clearPaymentInfo$ref() {
  if (ContractorBankInfo$clearPaymentInfo$refClass === VOID) {
    class $ {
      constructor(p0) {
        this.oje_1 = p0;
      }
      sao($completion) {
        return this.oje_1.qfs($completion);
      }
    }
    initMetadataForFunctionReference($, VOID, VOID, [0]);
    ContractorBankInfo$clearPaymentInfo$refClass = $;
  }
  return ContractorBankInfo$clearPaymentInfo$refClass;
}
function ContractorBankInfo$clearPaymentInfo$ref_0(p0) {
  var i = new (ContractorBankInfo$clearPaymentInfo$ref())(p0);
  var l = ($completion) => i.sao($completion);
  l.callableName = 'clearPaymentInfo';
  l.$arity = 0;
  return l;
}
var ContractorBankInfoClass;
function ContractorBankInfo() {
  if (ContractorBankInfoClass === VOID) {
    class $ extends DirectDepositInfo() {
      constructor() {
        super();
        this.jje_1 = new (Constant())(_Constant___init__impl__v45mub('Bank Info'));
        this.kje_1 = MemberRole_Admin_getInstance();
        var tmp = this;
        tmp.lje_1 = remember(VOID, VOID, VOID, ContractorBankInfo$contractor$lambda);
      }
      ucv() {
        return this.jje_1;
      }
      bhg() {
        return this.kje_1;
      }
      wi7($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_retrievePaymentInfo__nex0l8.bind(VOID, this), $completion);
      }
      aj3(_this__u8e3s4, request, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_setupPaymentInfo__dfdck1.bind(VOID, this, _this__u8e3s4, request), $completion);
      }
      qfs($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_clearPaymentInfo__j19g9t.bind(VOID, this), $completion);
      }
      pfs($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_clearDirectPaymentInfo__cg71g6.bind(VOID, this), $completion);
      }
      bj3(_this__u8e3s4, input, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_verifyBankInfo__73vm11.bind(VOID, this, _this__u8e3s4, input), $completion);
      }
      cj3($completion) {
        var tmp = get_dialogStack();
        var tmp_0 = ContractorBankInfo$financeConnectionComplete$ref_0(this);
        tmp.dbw(new (ContractorFinancialConnection())(tmp_0, ContractorBankInfo$clearPaymentInfo$ref_0(this)));
      }
      rhi(_this__u8e3s4) {
        var tmp = get_scrolling(_this__u8e3s4);
        // Inline function 'com.lightningkite.kiteui.views.direct.col' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (RowOrCol())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.xbm(true);
        view.zb8(get_rem(0));
        title(view, 'Bank Info');
        view.ibb(view.ibb(get_padded(view), sizeConstraints(view, VOID, VOID, VOID, VOID, VOID, get_AppDimensions().eg2_1)), get_section(view));
        this.xiw(view);
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.minus' call
        Companion_getInstance();
        _this__u8e3s4.fbb(p, view);
        _this__u8e3s4.jbb(tmp, view);
      }
    }
    protoOf($).ud6 = render;
    protoOf($).dhg = get_awaitingApprovalMessage;
    protoOf($).ehg = renderFinishRegistration;
    protoOf($).fhg = renderAwaitingApproval;
    initMetadataForClass($, 'ContractorBankInfo', ContractorBankInfo, VOID, [DirectDepositInfo(), ContractorPage()], [0, 2]);
    ContractorBankInfoClass = $;
  }
  return ContractorBankInfoClass;
}
//region block: exports
export {
  ContractorBankInfo as ContractorBankInfo3chkr569ztcs7,
};
//endregion

//# sourceMappingURL=ContractorBankInfo.mjs.map
